import React from 'react'
import Box from '@mui/material/Box'
import Table from '@mui/material/Table'
import TableBody from '@mui/material/TableBody'
import TableCell from '@mui/material/TableCell'
import TableContainer from '@mui/material/TableContainer'
import TableHead from '@mui/material/TableHead'
import TableRow from '@mui/material/TableRow'
import Paper from '@mui/material/Paper'


const LinkedProducts = ({products, selected, visible, onSelect,  ...rest}) => {
    
    return (
        <Box  sx={{scrollbarwidth: 'none', overflow: 'auto'}}>
            <TableContainer component={Paper}>
                <Table sx={{ minWidth: 650 }} aria-label="simple table">
                <TableHead>
                    <TableRow>
                    <TableCell alignt="left">Canal de Venta</TableCell>
                    <TableCell alignt="left">SKU</TableCell>
                    <TableCell alignt="left">asin</TableCell>
                    <TableCell alignt="left">Nombre</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {products.map((product) => visible.includes(product.id) && (
                        <TableRow
                            selected={selected.includes(product.id)}
                            onClick={() => onSelect(product.id)}
                            key={product.id}
                            sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                        >
                            <TableCell align="left">{product.vendor}</TableCell>
                            <TableCell align="left">{product.sku}</TableCell>
                            <TableCell align="left">{product.asin}</TableCell>
                            <TableCell align="left">{product.name}</TableCell>
                        </TableRow>
                    ))}
                </TableBody>
                </Table>
            </TableContainer>
        </Box>
    )
}
export default LinkedProducts